export default __webpack_public_path__ + "static/media/a1.c270ae19.png";